import React, {cloneElement} from "react";
import {SingleFieldList as RASingleFieldList} from "react-admin";

export const SingleFieldList = ({emptyText, children, ...props}) => {
    return props && props.ids && props.ids.length > 0 ?
        <RASingleFieldList linkType={false} style={{flexDirection: 'column'}} {...props}>
            {cloneElement(children)}
        </RASingleFieldList> : <span>{emptyText}</span>
};